import { Center, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const InitLoading = () => {
  const { t } = useTranslation();
  return (
    <Center minH='100vh'>
      <Heading color='cyan.500' size='md' fontWeight='normal'>
        {t('loading')}
      </Heading>
    </Center>
  );
};
